/* @flow */

export const validation = {
  maxTitleChar: 100,
  maxParagraphChar: 300,
  maxFormParagraphChar: 100
}
